import { useQuery } from "react-query";
import api from "../api";
import { API_ROUTES } from "../../utils/const";

const FETCH_ALL_CUSTOMERS = async (data) => {
    const response = await api.post(
        API_ROUTES.GET_ALL_CUSTOMERS,
        data
    )
    return response.data
}

export const getAllCustomers = (data) => {
    return useQuery({
        queryKey: ['allCustomers', data],
        queryFn: () => FETCH_ALL_CUSTOMERS(data),
        enabled: !!data.businessId
    })
}